import Icon from "@material-ui/icons/AssignmentInd";
import DriverList from "./DriverList";
import DriverShow from "./DriverShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "drivers",
  list: DriverList,
  show: DriverShow,
  icon: Icon,
};
